import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StarRatings from "react-star-ratings";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import moment from "moment";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { auth } from "../../actions/auth";
import { validateCoupon } from "../../actions/coupon";
import { validateTexjar } from "../../actions/texjar";
import { getCart } from "../../actions/cart";
import { shipmentAdd } from "../../actions/shipment";
import { payNow } from "../../actions/payment";
import { validateEasypost } from "../../actions/easypost";
import { cartAdd } from "../../actions/cart";
import { randomProducts } from "../../actions/products";

//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      number: true,
      open: false,
      cart: [],
      total: "",
      coupon: "",
      texjar: "",
      couponObject: "",
      couponValidMsg: null,
      texjarObject: "",
      texjarMessage: null,
      texjarSales: "",
      easypostObj: "",
      easypostObjs: [],
      easypostTex: 0,
      quantity: 1,
      shipment: 0,
      checkoutCheck: false,
      selectedValue: "",
      loading: true,
    };
  }
  componentDidMount() {
    if (localStorage.getItem("user")) {
      localStorage.setItem("checkout", false);
    } else {
      localStorage.setItem("checkout", true);
    }
    if (
      localStorage.getItem("cart") &&
      Object.keys(JSON.parse(localStorage.getItem("cart"))).length !== 0
    ) {
      this.setState({ checkoutCheck: true });
    }

    setInterval(async () => {
      const res = await this.props.getCart();
      this.setState({ cart: res });
      const priceArr = [];

      res &&
        res.forEach((element) => {
          priceArr.push(
            element.color && element.color
              ? element.item.enableSale === true
                ? Number(element.colorPrice) * element.quantity -
                  (Number(element.colorPrice) * element.item.saleDiscount) / 100
                : Number(element.colorPrice) * element.quantity
              : element.item.enableSale === true
              ? element.item.price * element.quantity -
                (element.item.price * element.item.saleDiscount) / 100
              : element.item.price * element.quantity
          );
        });
      var total = 0;
      for (var i in priceArr) {
        total += priceArr[i];
      }
      if (total < 49 && total !== 0) {
        this.setState({ shipment: 4.99 });
      }
      this.setState({ total: total });

      if (!res) {
        this.setState({ cart: [] });
      }
      var ship = 0;
      this.setState({ loading: false });
      if (localStorage.getItem("shipment") !== null) {
        if (
          Object.keys(JSON.parse(localStorage.getItem("shipment"))).length !== 0
        ) {
          const shipment = JSON.parse(localStorage.getItem("shipment"));
          shipment.forEach((element) => {
            ship += Number(element.selectedShipping.rate);
          });
          this.setState({ shipment: ship });
        }
      }
    }, 2000);

    this.getproducts();

    if (localStorage.getItem("zipcode") !== null) {
      if (
        Object.keys(JSON.parse(localStorage.getItem("zipcode"))).length !== 0
      ) {
        var texObj = JSON.parse(localStorage.getItem("zipcode"));
        this.setState({
          texjarObject: texObj,
        });

        this.setState({
          texjarSales: texObj.rate.combined_rate
            ? Number(texObj.rate.combined_rate) * 100
            : 0,
        });
      }
    }

    //   const s = document.createElement("script");
    //   s.type = "text/javascript";
    //   s.async = true;
    //   s.innerHTML = `$(document).ready(function(){
    //     var swiper1 = new Swiper('#slide1',   {
    //       slidesPerView: 5,
    //       centeredSlides: true,
    //       spaceBetween: 10,
    //       grabCursor: true,
    //       loop: true,
    //       // Navigation arrows
    //       navigation: {
    //           nextEl: '#firstArrows',
    //           prevEl: '#secondArrows',
    //       },
    //   });

    // // for all slider
    // var swiper2 = new Swiper('#slide2', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows2',
    //       prevEl: '#secondArrows2',
    //   },
    // });

    // var swiper2 = new Swiper('#slide3', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows3',
    //       prevEl: '#secondArrows3',
    //   },
    // });

    // var swiper2 = new Swiper('#slide4', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows4',
    //       prevEl: '#secondArrows4',
    //   },
    // });

    // var swiper2 = new Swiper('#slide5', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows5',
    //       prevEl: '#secondArrows5',
    //   },
    // });

    // var swiper2 = new Swiper('#slide6', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows6',
    //       prevEl: '#secondArrows6',
    //   },
    // });

    // var swiper2 = new Swiper('#slide7', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows7',
    //       prevEl: '#secondArrows7',
    //   },
    // });

    // var swiper2 = new Swiper('#slide8', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows8',
    //       prevEl: '#secondArrows8',
    //   },
    // });

    // var swiper2 = new Swiper('#slide9', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows9',
    //       prevEl: '#secondArrows9',
    //   },
    // });

    // var swiper2 = new Swiper('#slide10', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows10',
    //       prevEl: '#secondArrows10',
    //   },
    // });

    // var swiper2 = new Swiper('#slide11', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows11',
    //       prevEl: '#secondArrows11',
    //   },
    // });

    // var swiper2 = new Swiper('#slide12', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows12',
    //       prevEl: '#secondArrows12',
    //   },
    // });

    // var swiper2 = new Swiper('#slide13', {
    //   slidesPerView: 6,
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   grabCursor: true,
    //   loop: true,
    //    // Navigation arrows
    //   navigation: {
    //       nextEl: '#firstArrows13',
    //       prevEl: '#secondArrows13',
    //   },
    // });

    // $(document).ready(function () {
    //  setTimeout(function(){
    //      $("#slide1,#slide2,#slide3,#slide4,#slide5,#slide6,#slide7,#slide8,#slide9,#slide10,#slide11,#slide12,#slide13").css("transform", "translate3d(0px, 0px, 0px)");
    //     $(".swiper-wrapper").css("transform", "translate3d(-1200.58px, 0px, 0px)");
    //     }, 200)
    // })
    //   })`;
    //   // this.instance.appendChild(s);
  }

  cartBlukHandler = async () => {
    const data = {
      cardNumber: "4242424242424242",
      expirationDate: "0822",
      cardCode: "999",
      amount: this.state.total,
      items: this.state.cart,
      bill: {
        firstName: "Ellen",
        lastName: "Johnson",
        company: "Souveniropolis",
        address: "14 Main Street",
        city: "Pecan Springs",
        state: "TX",
        zip: "44628",
        country: "USA",
      },
      ship: {
        firstName: "Ellen",
        lastName: "Johnson",
        company: "Souveniropolis",
        address: "14 Main Street",
        city: "Pecan Springs",
        state: "TX",
        zip: "44628",
        country: "USA",
      },
    };

    const res = await this.props.payNow(data);
  };
  getproducts = async () => {
    const products = await this.props.randomProducts();

    this.setState({ products: products });
  };
  removeCartItem = (index) => {
    const cartArr = JSON.parse(localStorage.getItem("cart"));
    cartArr.splice(index, 1);
    localStorage.setItem("cart", JSON.stringify(cartArr));
    if (Object.keys(JSON.parse(localStorage.getItem("cart"))).length !== 0) {
      this.setState({ checkoutCheck: true });
    }
  };

  decreaseCartQuantity = (index) => {
    const cartArray = JSON.parse(localStorage.getItem("cart"));
    if (cartArray[index].quantity > 1) {
      cartArray[index].quantity = cartArray[index].quantity - 1;
      localStorage.setItem("cart", JSON.stringify(cartArray));
    }
  };
  increaseCartQuantity = (index) => {
    const cartArray = JSON.parse(localStorage.getItem("cart"));
    cartArray[index].quantity = cartArray[index].quantity + 1;
    localStorage.setItem("cart", JSON.stringify(cartArray));
  };
  setCartQuantity = (index, value) => {
    const cartArray = JSON.parse(localStorage.getItem("cart"));
    if (value === 10) {
      this.setState({ open: false });
    }
    if (cartArray[index].quantity !== 0) {
      cartArray[index].quantity = value;
      localStorage.setItem("cart", JSON.stringify(cartArray));
    }
  };
  _validateCoupon = async () => {
    const res = await this.props.validateCoupon({ coupon: this.state.coupon });

    if (res.status === true) {
      this.setState({ couponObject: res, couponValidMsg: true });
    } else if (res && res.status === false) {
      this.setState({ couponValidMsg: false, couponObject: [] });
    }

    setTimeout(() => {
      this.setState({ couponValidMsg: null });
    }, 3000);
  };

  _validateTexjar = async () => {
    const res = await this.props.validateTexjar({ texjar: this.state.texjar });

    if (res.status === true) {
      var sales = res.texjar.rate;
      this.setState({
        texjarObject: res.texjar,
        texjarMessage: true,
        texjarSales: Number(sales.combined_rate) * 100,
      });
      localStorage.setItem("zipcode", JSON.stringify(res.texjar));
    } else if (res && res.status === false) {
      this.setState({ texjarMessage: false });
    }
    setTimeout(() => {
      this.setState({ texjarMessage: null });
    }, 3000);
  };

  _easypost = async () => {
    const res = await this.props.getCart();
    var location = localStorage.getItem("location");

    res &&
      res.forEach((element) => {
        var brandId = element.item.brand;
        var productinfo = element.item;
        this.setState({
          location: JSON.parse(location),
          brandId: brandId,
          productInfo: productinfo,
        });
        // if (element.item.price < 49) {
        this._validateEasypost();
        // }
      });
  };
  _validateEasypost = async () => {
    const { location, brandId, productInfo } = this.state;

    const formData = {
      location: location,
      brandId: brandId,
      productInfo: productInfo,
    };

    const res = await this.props.validateEasypost(formData);

    if (res) {
      var obj = { 0: res, 1: [productInfo._id] };
      this.setState({
        easypostObjs: this.state.easypostObjs.concat([obj]),
      });
    } else if (res && res.status === false) {
      this.setState({ texjarMessage: false });
    }
    setTimeout(() => {
      this.setState({ texjarMessage: null });
    }, 3000);
  };
  _addToCart = async (item) => {
    const data = {
      item: item,
      quantity: this.state.quantity,
      color: this.state.orderColor,
    };
    // const cartAdd = await this.props.cartAdd(data);
    // if (cartAdd) {
    //   toast(`Product added in cart`, { containerId: "B" });
    // }
  };
  _addToShipping = async (product_id, epost, selectedShipping) => {
    const data = {
      epost: epost,
      selectedShipping: selectedShipping,
      product_id: product_id,
    };
    const cartAdd = await this.props.shipmentAdd(data);
    if (cartAdd) {
      toast(`Product added in cart`, { containerId: "B" });
    }
  };
  open1 = (check, item, index) => {
    let numbers = [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
    ];
    return check ? (
      <div className="myCart-quantity">
        <span>Quantity</span>
        <input type="number" />
      </div>
    ) : (
      <div className="myCart-quantity">
        <span>Quantity</span>
        <select
          defaultValue={item}
          onChange={(e) => {
            this.setCartQuantity(index, e.target.value);
            this.setState({
              selectedValue: e.target.value,
            });
          }}
        >
          {numbers.map((number) => {
            return <option value={number}>{number}</option>;
          })}
        </select>
      </div>
    );
  };
  chang = () => {
    this.setState({ number: false });
  };
  open2 = (check) => {
    return check ? (
      <a href="" onClick={(e) => this.chang()}>
        <i className="fa fa-phone" />
        Call Us
      </a>
    ) : (
      <a>
        <i className="fa fa-phone" />
        +1(888)969-0452
      </a>
    );
  };
  render() {
    const { user, isAuth } = this.props._auth;
    const { cart, easypostObjs, products, total } = this.state;

    return (
      <Fragment>
        {/* <BreadCrumb title={`Cart`} /> */}
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />
        <div className="my-cart wrapper-90 max-1600">
          <div className="container-fluid px-0">
            <div style={{ paddingLeft: "18px" }}>
              <div className="continue-shopping">
                <i className="fa fa-arrow-left" />
                <Link to={"/"}>Continue Shopping</Link>
              </div>
              <div className="my-cart-heading pt-3">
                <h3>My Cart</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8  order-2 order-md-1 order-lg-1">
                <div className="my-cart-main pt-sm-3">
                  <div className="cart-body">
                    {cart && cart.length !== 0 ? (
                      cart &&
                      cart.length > 0 &&
                      cart.map((item, index) =>
                        item.color && item.color ? (
                          <div
                            key={index}
                            className="row"
                            style={{
                              borderBottom: "1px solid #e0e0e0",
                              paddingTop: "10px",
                            }}
                          >
                            {item.item.attribute &&
                              item.item.attribute.map((attrib, indx) =>
                                JSON.parse(attrib).color === item.color ? (
                                  <Fragment>
                                    {" "}
                                    <div className="col-md-2 col-sm-6">
                                      <div className="myCart-img">
                                        <img
                                          src={
                                            item.item.images[
                                              JSON.parse(attrib).image
                                            ]
                                          }
                                          width="100%"
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-8 col-md-7 col-sm-6">
                                      <div className="myCart-img-details">
                                        <p className="m-0">
                                          <Link
                                            to={`/product/${item.item.slug}`}
                                          >
                                            {item && item.item.title}
                                          </Link>
                                        </p>
                                        <p className="m-0">
                                          Model &nbsp; &nbsp; :{" "}
                                          {item && item.item.model}
                                        </p>

                                        <p className="m-0">
                                          Color &nbsp; &nbsp; :{" "}
                                          {JSON.parse(attrib).color}
                                        </p>
                                        <div className="myCart-rating">
                                          <ul className="myCart-rating-list">
                                            <StarRatings
                                              rating={
                                                item.item && item.item.reviews
                                                  ? item.item.reviews /
                                                    item.item.reviewCount
                                                  : 0
                                              }
                                              starDimension="20px"
                                              starSpacing="2px"
                                              starRatedColor="gold"
                                            />
                                            <span>
                                              {item.item &&
                                                item.item.reviewCount}
                                            </span>
                                          </ul>
                                        </div>
                                        <div className="myCart-color">
                                          <span></span>
                                        </div>
                                        <div className="myCart-size">
                                          <span></span>
                                        </div>
                                        <div className="myCart-getDate mt-3">
                                          <span>
                                            {" "}
                                            Get it By{" "}
                                            {moment()
                                              .add(4, "days")
                                              .format("ddd D MMM, YYYY")}{" "}
                                            - Ground
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3">
                                      <div
                                        className="myCart-price"
                                        style={{ color: "red" }}
                                      >
                                        <span>
                                          {" "}
                                          $
                                          {item.item.enableSale === true
                                            ? JSON.parse(attrib).price *
                                                item.quantity -
                                              (JSON.parse(attrib).price *
                                                item.item.saleDiscount) /
                                                100
                                            : JSON.parse(attrib).price *
                                              item.quantity}
                                        </span>
                                        {item.item.enableSale === true ? (
                                          <del className="moda-right-price-off">
                                            $
                                            {Number(
                                              JSON.parse(attrib).price
                                            ).toFixed(2)}
                                          </del>
                                        ) : null}
                                      </div>
                                      <div
                                        className="myCart-price"
                                        style={{ fontSize: "10px" }}
                                      >
                                        {item &&
                                          Number(item.item.price).toFixed(2)}
                                        per item
                                      </div>
                                      <div className="myCart-quantity">
                                        <span>Quantity</span>
                                        <select
                                          defaultValue={item.quantity}
                                          onChange={(e) => {
                                            this.setCartQuantity(
                                              index,
                                              e.target.value
                                            );
                                          }}
                                        >
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                          <option value="3">3</option>
                                          <option value="4">4</option>
                                          <option value="5">5</option>
                                          <option value="6">6</option>
                                          <option value="7">7</option>
                                          <option value="8">8</option>
                                          <option value="9">9</option>
                                          <option value="10">10</option>
                                          <option value="11">11</option>
                                          <option value="12">12</option>
                                          <option value="13">13</option>
                                          <option value="14">14</option>
                                          <option value="15">15</option>
                                          <option value="16">16</option>
                                          <option value="17">17</option>
                                          <option value="18">18</option>
                                          <option value="19">19</option>
                                          <option value="20">20</option>
                                        </select>
                                      </div>
                                      <div className="myCart-save"></div>
                                      <div
                                        className="myCart-remove"
                                        onClick={() => {
                                          this.removeCartItem(index);
                                        }}
                                      >
                                        <i className="fas fa-trash-alt" />
                                        &nbsp;
                                        <span>Remove</span>
                                      </div>
                                    </div>
                                  </Fragment>
                                ) : null
                              )}
                          </div>
                        ) : (
                          <div
                            key={index}
                            className="row"
                            style={{
                              borderBottom: "1px solid #e0e0e0",
                              paddingTop: "12px",
                            }}
                          >
                            <div className="col-md-2 col-sm-6">
                              <div className="myCart-img">
                                <img
                                  src={item.item.mainImage}
                                  width="100%"
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="col-lg-8 col-md-7 col-sm-6">
                              <div className="myCart-img-details">
                                <p className="m-0">
                                  <Link to={`/product/${item.item.slug}`}>
                                    {item.item.title}
                                  </Link>
                                </p>
                                <p className="m-0">
                                  Model &nbsp; &nbsp; : {item.item.model}
                                </p>

                                <div className="myCart-rating">
                                  <ul className="myCart-rating-list">
                                    <StarRatings
                                      rating={
                                        item.item && item.item.reviews
                                          ? item.item.reviews /
                                            item.item.reviewCount
                                          : 0
                                      }
                                      starDimension="20px"
                                      starSpacing="2px"
                                      starRatedColor="gold"
                                    />
                                    <span>
                                      {item.item && item.item.reviewCount}
                                    </span>
                                  </ul>
                                </div>
                                <div className="myCart-color">
                                  <span></span>
                                </div>
                                <div className="myCart-size">
                                  <span></span>
                                </div>
                                <div className="myCart-getDate mt-3">
                                  <span>
                                    {" "}
                                    Get it By{" "}
                                    {moment()
                                      .add(4, "days")
                                      .format("ddd D MMM, YYYY")}{" "}
                                    - Ground
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                              <div
                                className="myCart-price"
                                style={{ color: "red" }}
                              >
                                <span>
                                  {
                                    item && item.item.price * item.quantity

                                    /*  item.item.enableSale === true
                                    ? item.item.price * item.quantity -
                                      (item.item.price *
                                        item.item.saleDiscount) /
                                        100
                                    : item.item.price * item.item.quantity  */
                                  }
                                </span>
                                {item.item.enableSale === true ? (
                                  <del className="moda-right-price-off">
                                    ${Number(item.item.price).toFixed(2)}
                                  </del>
                                ) : null}
                              </div>
                              <div
                                className="myCart-price"
                                style={{ fontSize: "12px" }}
                              >
                                {item && Number(item.item.price).toFixed(2)} per
                                item
                              </div>

                              {this.open1(
                                this.state.open,
                                item.quantity,
                                index
                              )}

                              <div className="myCart-save"></div>
                              <div
                                className="myCart-remove"
                                onClick={() => {
                                  this.removeCartItem(index);
                                }}
                              >
                                <i className="fas fa-trash-alt" />
                                &nbsp;
                                <span>Remove</span>
                              </div>
                            </div>
                          </div>
                        )
                      )
                    ) : (
                      <div className="">
                        {this.state.loading === false ? (
                          <span>
                            <h3>Your Shopping Cart Is Empty</h3>
                            <p>
                              Save big on our{" "}
                              <Link
                                className="default-color underLined   underline-hovered"
                                to={"/daily-sale"}
                              >
                                Featured Sales
                              </Link>{" "}
                            </p>
                          </span>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
                <div className="myCart-footer">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="myCart-shoping-assistance">
                        <p className="assistance-heading">
                          Shopping Assistance
                        </p>
                        <p className="in-txt">
                          Have any questions before you check out? We're here to
                          help!
                        </p>
                        <p className="cart-call">
                          {this.open2(this.state.number)}
                          {/* <a href="tel:18889690452">
                            <i className="fa fa-phone" />
                            Call Us
                          </a> */}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 px-md-5">
                      <div className="myCart-return-policy">
                        <p className="return-heading">Return Policy</p>
                        <p className="in-txt">
                          Most items can be returned within 30 days of delivery.
                        </p>
                        <p className="cart-more">
                          <Link to={"/return-policy"}>Learn More</Link>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <h3 className="you-need">You Might Also Need</h3>
                    <div className="col-md-12 ">
                      <div className="categoriesslider">
                        {products && products.length > 0 ? (
                          <div>
                            <OwlCarousel
                              className="owl-theme fiveScreen-owlCarousel"
                              loop
                              items={4}
                              margin={10}
                              nav
                              autoplaySpeed={true}
                              autoplay={true}
                              autoplayTimeout={3000}
                              autoplayHoverPause={true}
                              animateOut={true}
                            >
                              {products &&
                                products.map((item, index) => (
                                  <div key={index} className="item ">
                                    <div className="product-cards h-100">
                                      <div className="product-cards-img">
                                        <img
                                          src={item.mainImage && item.mainImage}
                                          width="100%"
                                          alt=""
                                        />
                                      </div>
                                      <div className="product-cards-price">
                                        <span>${item.price}</span>
                                      </div>

                                      <div className="product-cards-content">
                                        <div className="product-cards-txt">
                                          <Link to={`/product/${item.slug}`}>
                                            {item && item.title}
                                          </Link>

                                          <div className="product-cards-rating">
                                            <ul className="product-rating">
                                              <StarRatings
                                                rating={
                                                  item.reviews
                                                    ? item.reviews /
                                                      item.reviewCount
                                                    : 0
                                                }
                                                starDimension="20px"
                                                starSpacing="2px"
                                                starRatedColor="gold"
                                              />
                                              <span>{item.reviewCount}</span>
                                            </ul>
                                            <span>
                                              {item.price > 49 ? (
                                                <b>Free Shipping</b>
                                              ) : (
                                                <b></b>
                                              )}
                                            </span>
                                          </div>
                                          <div className="add-cart text-center">
                                            <button
                                              className="add-myCart"
                                              onClick={() => {
                                                this._addToCart(item && item);
                                              }}
                                            >
                                              <span>
                                                <i className="fas fa-cart-plus" />
                                                &nbsp; Add
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </OwlCarousel>
                            <OwlCarousel
                              className="owl-theme fourScreen-owlCarousel "
                              style={{ display: "none" }}
                              loop
                              items={3}
                              margin={10}
                              nav
                              autoplaySpeed={true}
                              autoplay={true}
                              autoplayTimeout={3000}
                              autoplayHoverPause={true}
                              animateOut={true}
                            >
                              {products &&
                                products.map((item, index) => (
                                  <div key={index} className="item ">
                                    <div className="product-cards">
                                      <div className="product-cards-img">
                                        <img
                                          src={item.images && item.images[0]}
                                          width="100%"
                                          alt=""
                                        />
                                      </div>
                                      <div className="product-cards-content">
                                        <div className="product-cards-txt">
                                          <Link to={`/product/${item.slug}`}>
                                            {item && item.title}
                                          </Link>
                                          <div className="product-cards-price">
                                            <span>${item.price}</span>
                                          </div>
                                          <div className="product-cards-rating">
                                            <ul className="product-rating">
                                              <StarRatings
                                                rating={
                                                  item.reviews
                                                    ? item.reviews /
                                                      item.reviewCount
                                                    : 0
                                                }
                                                starDimension="20px"
                                                starSpacing="2px"
                                                starRatedColor="gold"
                                              />
                                              <span>{item.reviewCount}</span>
                                            </ul>
                                            <span>
                                              {item.price > 49 ? (
                                                <b>Free Shipping</b>
                                              ) : (
                                                <b></b>
                                              )}
                                            </span>
                                          </div>
                                          <div className="add-cart text-center">
                                            <button
                                              className="add-myCart"
                                              onClick={() => {
                                                this._addToCart(item && item);
                                              }}
                                            >
                                              <span>
                                                <i className="fas fa-cart-plus" />
                                                &nbsp; Add
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </OwlCarousel>
                            <OwlCarousel
                              className="owl-theme threeScreen-owlCarousel"
                              style={{ display: "none" }}
                              loop
                              items={2}
                              margin={10}
                              nav
                              autoplaySpeed={true}
                              autoplay={true}
                              autoplayTimeout={3000}
                              autoplayHoverPause={true}
                              animateOut={true}
                            >
                              {products &&
                                products.map((item, index) => (
                                  <div key={index} className="item ">
                                    <div className="product-cards">
                                      <div className="product-cards-img">
                                        <img
                                          src={item.images && item.images[0]}
                                          width="100%"
                                          alt=""
                                        />
                                      </div>
                                      <div className="product-cards-content">
                                        <div className="product-cards-txt">
                                          <Link to={`/product/${item.slug}`}>
                                            {item && item.title}
                                          </Link>
                                          <div className="product-cards-price">
                                            <span>${item.price}</span>
                                          </div>
                                          <div className="product-cards-rating">
                                            <ul className="product-rating">
                                              <StarRatings
                                                rating={
                                                  item.reviews
                                                    ? item.reviews /
                                                      item.reviewCount
                                                    : 0
                                                }
                                                starDimension="20px"
                                                starSpacing="2px"
                                                starRatedColor="gold"
                                              />
                                              <span>{item.reviewCount}</span>
                                            </ul>
                                            <span>
                                              {item.price > 49 ? (
                                                <b>Free Shipping</b>
                                              ) : (
                                                <b></b>
                                              )}
                                            </span>
                                          </div>
                                          <div className="add-cart text-center">
                                            <button
                                              className="add-myCart"
                                              onClick={() => {
                                                this._addToCart(item && item);
                                              }}
                                            >
                                              <span>
                                                <i className="fas fa-cart-plus" />
                                                &nbsp; Add
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </OwlCarousel>
                            <OwlCarousel
                              className="owl-theme twoScreen-owlCarousel"
                              style={{ display: "none" }}
                              loop
                              items={2}
                              margin={10}
                              nav
                              autoplaySpeed={true}
                              autoplay={true}
                              autoplayTimeout={3000}
                              autoplayHoverPause={true}
                              animateOut={true}
                            >
                              {products &&
                                products.map((item, index) => (
                                  <div key={index} className="item ">
                                    <div className="product-cards">
                                      <div className="product-cards-img">
                                        <img
                                          src={item.images && item.images[0]}
                                          width="100%"
                                          alt=""
                                        />
                                      </div>
                                      <div className="product-cards-content">
                                        <div className="product-cards-txt">
                                          <Link to={`/product/${item.slug}`}>
                                            {item && item.title}
                                          </Link>
                                          <div className="product-cards-price">
                                            <span>${item.price}</span>
                                          </div>
                                          <div className="product-cards-rating">
                                            <ul className="product-rating">
                                              <StarRatings
                                                rating={
                                                  item.reviews
                                                    ? item.reviews /
                                                      item.reviewCount
                                                    : 0
                                                }
                                                starDimension="20px"
                                                starSpacing="2px"
                                                starRatedColor="gold"
                                              />
                                              <span>{item.reviewCount}</span>
                                            </ul>
                                            <span>
                                              {item.price > 49 ? (
                                                <b>Free Shipping</b>
                                              ) : (
                                                <b></b>
                                              )}
                                            </span>
                                          </div>
                                          <div className="add-cart text-center">
                                            <button
                                              className="add-myCart"
                                              onClick={() => {
                                                this._addToCart(item && item);
                                              }}
                                            >
                                              <span>
                                                <i className="fas fa-cart-plus" />
                                                &nbsp; Add
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </OwlCarousel>
                            <OwlCarousel
                              className="owl-theme oneScreen-owlCarousel"
                              style={{ display: "none" }}
                              loop
                              items={1}
                              margin={10}
                              nav
                              dots={false}
                              autoplaySpeed={true}
                              autoplay={true}
                              autoplayTimeout={3000}
                              autoplayHoverPause={true}
                              animateOut={true}
                            >
                              {products &&
                                products.map((item, index) => (
                                  <div key={index} className="item ">
                                    <div className="product-cards">
                                      <div className="product-cards-img">
                                        <img
                                          src={item.images && item.images[0]}
                                          width="100%"
                                          alt=""
                                        />
                                      </div>
                                      <div className="product-cards-content">
                                        <div className="product-cards-txt">
                                          <Link to={`/product/${item.slug}`}>
                                            {item && item.title}
                                          </Link>
                                          <div className="product-cards-price">
                                            <span>${item.price}</span>
                                          </div>
                                          <div className="product-cards-rating">
                                            <ul className="product-rating">
                                              <StarRatings
                                                rating={
                                                  item.reviews
                                                    ? item.reviews /
                                                      item.reviewCount
                                                    : 0
                                                }
                                                starDimension="20px"
                                                starSpacing="2px"
                                                starRatedColor="gold"
                                              />
                                              <span>{item.reviewCount}</span>
                                            </ul>
                                            <span>
                                              {item.price > 49 ? (
                                                <b>Free Shipping</b>
                                              ) : (
                                                <b></b>
                                              )}
                                            </span>
                                          </div>
                                          <div className="add-cart text-center">
                                            <button
                                              className="add-myCart"
                                              onClick={() => {
                                                this._addToCart(item && item);
                                              }}
                                            >
                                              <span>
                                                <i className="fas fa-cart-plus" />
                                                &nbsp; Add
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </OwlCarousel>
                          </div>
                        ) : (
                          <span>Loading...</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4  order-1 order-md-2 order-lg-2">
                <div className="checkout-main-right">
                  <div className="checkout-stick-popup">
                    {total > 49 || total === 49 ? (
                      <>
                        <div className="text-left py-2 changePcondition">
                          <span>
                            <i className="fa fa-truck" />
                          </span>
                          &nbsp;&nbsp;
                          <span>this order qualify for free shipping</span>
                        </div>
                      </>
                    ) : (
                      <div></div>
                    )}

                    <div className="myCart-right-side">
                      <div className="myCart-popup">
                        <div className="myCart-popup-body">
                          <div className="itemSub-total">
                            <span>Item Subtotal:</span>
                            <span>
                              $
                              {this.state.total &&
                                Number(this.state.total).toFixed(2)}
                            </span>
                          </div>
                          <div className="myCart-shipto">
                            <div
                              className="card"
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                              }}
                            >
                              <div>
                                {this.state.texjarMessage !== null &&
                                  this.state.texjarMessage === false && (
                                    <div
                                      className="alert alert-danger"
                                      role="alert"
                                      style={{ padding: "0px" }}
                                    >
                                      Zipcode not valid!
                                    </div>
                                  )}

                                {this.state.texjarMessage !== null &&
                                  this.state.texjarMessage === true && (
                                    <div
                                      className="alert alert-success"
                                      role="alert"
                                      style={{ padding: "0px" }}
                                    >
                                      Zipcode applied!
                                    </div>
                                  )}
                                <a
                                  className="default-color"
                                  href="!#"
                                  data-toggle="collapse"
                                  data-target="#product1-shipto-collapse"
                                  aria-expanded="true"
                                  aria-controls="product1-shipto-collapse"
                                >
                                  <span className="myCartShip">Ship to:</span>
                                  {this.state.texjarObject &&
                                    this.state.texjarObject.rate.zip}
                                  {this.state.texjarObject &&
                                    this.state.texjarObject.rate.city !==
                                      null &&
                                    "-" + this.state.texjarObject.rate.city}
                                  <i className="fa fa-angle-down" />
                                </a>
                              </div>
                              <div
                                id="product1-shipto-collapse"
                                className="collapse"
                                aria-labelledby="headingOne"
                                data-parent="#product1-shipto"
                              >
                                <div
                                  className="card-body pl-0 inputDropD-body"
                                  id="myCart-zip"
                                >
                                  <input
                                    type="text"
                                    placeholder="Zip Code"
                                    id="update-cart-zip"
                                    className="cartDropDown-input"
                                    autoFocus
                                    onChange={(e) =>
                                      this.setState({ texjar: e.target.value })
                                    }
                                  />
                                  <span
                                    className="update-zipcode"
                                    onClick={this._validateTexjar}
                                  >
                                    Update
                                  </span>
                                </div>
                              </div>
                            </div>
                            <span>
                              {this.state.total && this.state.total === 0
                                ? "$0.00"
                                : this.state.total < 49
                                ? "$" + this.state.shipment
                                : "Free"}
                            </span>
                          </div>
                          <div className="myCart-shipto">
                            <div
                              className="card"
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                              }}
                            >
                              <div>
                                {this.state.couponValidMsg !== null &&
                                  this.state.couponValidMsg === false && (
                                    <div
                                      className="alert alert-danger"
                                      role="alert"
                                      style={{ padding: "0px" }}
                                    >
                                      Coupon not valid!
                                    </div>
                                  )}

                                {this.state.couponValidMsg !== null &&
                                  this.state.couponValidMsg === true && (
                                    <div
                                      className="alert alert-success"
                                      role="alert"
                                      style={{ padding: "0px" }}
                                    >
                                      Coupon applied!
                                    </div>
                                  )}
                                <a
                                  className="default-color"
                                  href="!#"
                                  data-toggle="collapse"
                                  data-target="#product1-coupon-collapse"
                                  aria-expanded="true"
                                  aria-controls="product1-coupon-collapse"
                                >
                                  <span className="myCartShip">Coupon:</span>
                                  {this.state.coupon && this.state.coupon}
                                  <i className="fa fa-angle-down" />
                                </a>
                              </div>
                              <div
                                id="product1-coupon-collapse"
                                className="collapse"
                                aria-labelledby="headingOne"
                                data-parent="#product1-coupon"
                              >
                                <div
                                  className="card-body pl-0 inputDropD-body"
                                  id="myCart-zip"
                                >
                                  <input
                                    type="text"
                                    placeholder="Coupon Code"
                                    id="coupon_code"
                                    className="cartDropDown-input"
                                    autoFocus
                                    onChange={(e) => {
                                      this.setState({ coupon: e.target.value });
                                    }}
                                  />
                                  <span
                                    className="update-zipcode"
                                    onClick={this._validateCoupon}
                                  >
                                    Apply
                                  </span>
                                </div>
                              </div>
                            </div>
                            <span>
                              $
                              {this.state.couponValidMsg === true &&
                              this.state.couponObject
                                ? Number(
                                    (this.state.couponObject.coupon
                                      .pricePercentage /
                                      100) *
                                      this.state.total
                                  ).toFixed(2)
                                : 0}
                            </span>
                          </div>
                          <div className="myCart-tax">
                            <span className="tax">Tax:</span>
                            <span>
                              $
                              {this.state.texjarSales &&
                                Number(
                                  (this.state.texjarSales / 100) *
                                    this.state.total
                                ).toFixed(2)}
                            </span>
                          </div>
                          <div className="myCart-total">
                            <span>Total: </span>
                            <span>
                              $
                              {this.state.total &&
                              this.state.couponValidMsg === true &&
                              this.state.couponObject
                                ? Number(
                                    this.state.shipment +
                                      this.state.total -
                                      (this.state.couponObject.coupon
                                        .pricePercentage /
                                        100) *
                                        this.state.total +
                                      (this.state.texjarSales / 100) *
                                        this.state.total
                                  ).toFixed(2)
                                : Number(
                                    this.state.shipment +
                                      this.state.total +
                                      (this.state.texjarSales / 100) *
                                        this.state.total
                                  ).toFixed(2)}
                            </span>
                          </div>
                          <div className="myCart-save">
                            <span>You Save:</span>
                            <span>
                              $
                              {this.state.couponValidMsg === true
                                ? Number(
                                    (this.state.couponObject.coupon
                                      .pricePercentage /
                                      100) *
                                      this.state.total
                                  ).toFixed(2)
                                : 0}
                            </span>
                          </div>

                          <div className="proceed-checkout">
                            {this.state.texjarSales &&
                            this.state.texjarSales !== "" ? (
                              user && user.isVendor ? (
                                <Link className="proceed-checkout-btn">
                                  <i className="fa fa-lock" />
                                  <span> Seller Can't Checkout</span>
                                </Link>
                              ) : this.state.checkoutCheck &&
                                this.state.checkoutCheck &&
                                user &&
                                user.isVendor !== true ? (
                                <Link
                                  onClick={() => {
                                    localStorage.setItem(
                                      "coupon",
                                      JSON.stringify(this.state.couponObject)
                                    );
                                  }}
                                  to={"/checkout"}
                                  className="proceed-checkout-btn"
                                >
                                  <i className="fa fa-lock" />{" "}
                                  <span>Proceed To Checkout</span>
                                </Link>
                              ) : isAuth ? (
                                <Link className="proceed-checkout-btn">
                                  <i className="fa fa-lock" />{" "}
                                  <span>Please Add Some Products to cart</span>
                                </Link>
                              ) : (
                                <Link
                                  to={"/checkout"}
                                  className="proceed-checkout-btn"
                                >
                                  <i className="fa fa-lock" />{" "}
                                  <span>Proceed to Checkout</span>
                                </Link>
                              )
                            ) : (
                              <Link className="proceed-checkout-btn">
                                <i className="fa fa-lock" />{" "}
                                <span
                                  href="!#"
                                  data-toggle="collapse"
                                  data-target="#product1-shipto-collapse"
                                  aria-expanded="true"
                                  aria-controls="product1-shipto-collapse"
                                  style={{ color: "#fff" }}
                                >
                                  Please Add Zipcode
                                </span>
                              </Link>
                            )}
                          </div>
                        </div>

                        <div className="myCart-right-footer">
                          {total < 49 /* || total !== 49 */ ? (
                            <>
                              <div className="myCart-shipping-icon">
                                <span>
                                  <i className="fa fa-truck" />
                                </span>
                              </div>
                              <div className="myCart-shipping_">
                                <span>
                                  <span>
                                    You're ${Number(49 - total).toFixed(2)} from
                                    FREE Shipping
                                  </span>
                                  <div className="myCart-range">
                                    <div
                                      className="shipping-range"
                                      style={{
                                        width: `${(total * 100) / 49}%`,
                                      }}
                                    />
                                  </div>
                                  {/*  <span>Shipping is Free For You</span>
                            <div className="myCart-range">
                              <div
                                className="shipping-range"
                                style={{ width: "100%" }}
                              />
                            </div> */}
                                </span>
                              </div>
                            </>
                          ) : (
                            <span>
                              {/*  <span>
                              You're ${Number(49 - total).toFixed(2)} from FREE
                              Shipping
                            </span>
                            <div className="myCart-range">
                              <div
                                className="shipping-range"
                                style={{ width: `${(total * 100) / 49}%` }}
                              />
                            </div> */}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={(el) => (this.instance = el)}></div>
      </Fragment>
    );
  }
}

payNow.propTypes = {
  payNow: PropTypes.func.isRequired,
};

getCart.propTypes = {
  getCart: PropTypes.func.isRequired,
};
shipmentAdd.propTypes = {
  shipmentAdd: PropTypes.func.isRequired,
};

validateCoupon.propTypes = {
  validateCoupon: PropTypes.func.isRequired,
};
validateTexjar.propTypes = {
  validateTexjar: PropTypes.func.isRequired,
};
validateEasypost.propTypes = {
  validateEasypost: PropTypes.func.isRequired,
};
auth.propsTypes = {
  auth: PropTypes.func.isRequired,
};
randomProducts.propTypes = {
  randomProducts: PropTypes.func.isRequired,
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, {
  payNow,
  getCart,
  validateCoupon,
  validateTexjar,
  auth,
  validateEasypost,
  randomProducts,
  cartAdd,
  shipmentAdd,
})(Login);
